import React, { useEffect, useRef, useState } from 'react'
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BiotechIcon from '@mui/icons-material/Biotech';
import ChecklistIcon from '@mui/icons-material/Checklist';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

import MenuIcon from '@mui/icons-material/Menu';

import SearchIcon from '@mui/icons-material/Search';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CategoryIcon from '@mui/icons-material/Category';
import SettingsIcon from '@mui/icons-material/Settings';
import PostAddIcon from '@mui/icons-material/PostAdd';

import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import Accordion from 'react-bootstrap/Accordion';

import DashboardContext from '../components/DashboardContext.jsx';
import LaboratoryLists from '../components/LaboratoryLists';

import UserSetup from '../components/UserSetup.jsx';
import ItemsList from '../components/ItemsList.jsx';
import GenerateBarcde from '../components/GenerateBarcde.jsx';
import WarrantyCard from '../components/WarrantyCard.jsx';
import Settings from '../components/Settings.jsx';
import OnPrinting from '../components/OnPrinting.jsx';
import OnAssignLab from '../components/OnAssignLab.jsx';
import UsedBarcodeList from '../components/UsedBarcodeList.jsx';
import ProductType from '../components/ProductType.jsx';
import AddWarrantyCard from '../components/AddWarrantyCard.jsx';
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from 'axios';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function Dashboard({ serverURL, user, setUser }) {
  let globalUserId = null
  let globalToken = null

  const { jsonToCSV } = usePapaParse();
  const { CSVDownloader, Type } = useCSVDownloader();


  const [contextViews, setContextViews] = useState("Dashboard")
  const [showUserOverlay, setShowUserOverlay] = useState(false);
  const [showSideOverlay, setShowSideOverlay] = useState(false);
  const [logs, setLogs] = useState([])
  const [showSideOverlayLogs, setShowSideOverlayLogs] = useState(false);

  const [adminView, setAdminView] = useState("");
  const triggerted = useRef(null)

  const [userLoading, setUserLoading] = useState(true);

  const logoutFunc = async (e) => {
    const storeCookies = await axios.get(serverURL + "/deleteCookie/", { withCredentials: true });
    if (storeCookies) {
      window.location.href = "/"
    } else {
      console.log("Enable to Logout")
    }
  }

  const updateLog = async (data) => {
    const dataSet = {
      "userId": user.userId,
      "changes": data,
    }
    const updateNow = await axios.post(serverURL + "/users/updateLog", dataSet)
    if (updateNow.status == 200) {
      console.log(updateNow.data)
    } else {
      console.log(updateNow.data)
    }
  }

  const getAllLogs = async () => {
    const allLogs = await axios.post(serverURL + "/users/getLogs", { "type": "all", "userId": user.userId })

    if (allLogs.status == 200) {
      setLogs(allLogs.data)
    } else {
      console.log(allLogs.data)
    }
  }

  const checkCookies = async () => {
    setUserLoading(true);

    const getCookies = await axios.get(serverURL + "/getCookieUser", { withCredentials: true });
    if (getCookies.status == 200) {
      // console.log(getCookies.data);
      let globalUserId = getCookies.data.user;
      let globalToken = getCookies.data.token;



      const checkValidCookies = await axios.post(serverURL + "/users/checkValidCookies", { "userId": globalUserId, "token": globalToken })

      if (checkValidCookies.status == 200) {
        const findUser = await axios.post(serverURL + "/users/find", { userId: globalUserId })
        if (findUser.status == 200) {
          setUser(findUser.data[0])
          if (findUser.data[0].designation === "Labs") {
            setAdminView("Labs")
          } else {
            setAdminView("SuperAdmin")
          }
          setUserLoading(false);
          getAllLogs();
        } else {
          // console.log(findUser.data)
          window.location.href = "/"
        }
      } else {
        // console.log(checkValidCookies.data)
        window.location.href = "/"
      }
    } else {
      // console.log(getCookies.data)
      window.location.href = "/"
    }
  }

  useEffect(() => {
    checkCookies()
  }, [])

  return (
    <>
      <div className='vh-100 vw-100 d-flex flex-column mainBigPanel'>
        <div className='d-flex h-100 w-100'>
          <div className='leftSidebar h-100 w-100 text-center d-none d-lg-block d-xl-block'>
            <div>
              <img src="https://www.dentaldirekt.de/themes/custom/webksdct/logo.svg" alt="" className='w-100 mt-1 mb-5' style={{ maxWidth: "150px" }} />
            </div>
            {
              !userLoading ?
                adminView === "SuperAdmin" ?
                  <>
                    <button className={`leftMenueButtons ${contextViews === "Dashboard" ? "active" : ""}`} onClick={(e) => { setContextViews("Dashboard"); }}><DashboardCustomizeIcon style={{ width: ".9em" }} />Dashboard</button>
                    <button className={`leftMenueButtons ${contextViews === "Laboratory Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Laboratory Lists"); }}><BiotechIcon style={{ width: ".9em" }} /> Laboratory Lists</button>
                    <button className={`leftMenueButtons ${contextViews === "Items Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Items Lists"); }}><ChecklistIcon style={{ width: ".9em" }} /> Items Lists</button>
                    <button className={`leftMenueButtons ${contextViews === "User List" ? "active" : ""}`} onClick={(e) => { setContextViews("User List"); }}><RecentActorsIcon style={{ width: ".9em" }} /> User List</button>
                    {/* <button className={`leftMenueButtons ${contextViews === "Lab Registtration" ? "active" : ""}`} onClick={(e) => { setContextViews("Lab Registtration"); }}><ScienceIcon style={{ width: ".8em" }} />Lab Registtration</button> */}
                    {/* <button className={`leftMenueButtons ${contextViews === "Create Items Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Create Items Lists"); }}><FeaturedPlayListIcon style={{ width: ".8em" }} />Create Items Lists</button> */}
                    <button className={`leftMenueButtons ${contextViews === "Generated BarCode" ? "active" : ""}`} onClick={(e) => { setContextViews("Generated BarCode"); }}><QrCode2Icon style={{ width: ".9em" }} />Generated BarCode</button>
                    <button className={`leftMenueButtons ${contextViews === "On Printing" ? "active" : ""}`} onClick={(e) => { setContextViews("On Printing"); }}><LocalPrintshopIcon style={{ width: ".9em" }} />On Printing</button>
                    <button className={`leftMenueButtons ${contextViews === "On Assign Lab" ? "active" : ""}`} onClick={(e) => { setContextViews("On Assign Lab"); }}><AssignmentIndIcon style={{ width: ".9em" }} />On Assign Lab</button>
                    <button className={`leftMenueButtons ${contextViews === "Product Type" ? "active" : ""}`} onClick={(e) => { setContextViews("Product Type"); }}><CategoryIcon style={{ width: ".9em" }} />Product Type</button>
                    <button className={`leftMenueButtons ${contextViews === "Used Barcode List" ? "active" : ""}`} onClick={(e) => { setContextViews("Used Barcode List"); }}><QrCode2Icon style={{ width: ".9em" }} />Used Barcode List</button>
                    <button className={`leftMenueButtons ${contextViews === "Settings" ? "active" : ""}`} onClick={(e) => { setContextViews("Settings"); }}><SettingsIcon style={{ width: ".9em" }} />Settings</button>
                  </>
                  :
                  <>
                    <button className={`leftMenueButtons ${contextViews === "Dashboard" ? "active" : ""}`} onClick={(e) => { setContextViews("Dashboard"); }}><DashboardCustomizeIcon style={{ width: ".9em" }} />Dashboard</button>
                    <button className={`leftMenueButtons ${contextViews === "Add Warranty Card" ? "active" : ""}`} onClick={(e) => { setContextViews("Add Warranty Card"); }}><PostAddIcon style={{ width: ".9em" }} />Add Warranty Card</button>
                    <button className={`leftMenueButtons ${contextViews === "Issued Warranty Card" ? "active" : ""}`} onClick={(e) => { setContextViews("Issued Warranty Card"); }}><HealthAndSafetyIcon style={{ width: ".9em" }} />Issued Warranty Card</button>
                  </>
                :
                <SkeletonTheme highlightColor='#d8733934'>
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                  <Skeleton height={35} style={{ marginBottom: "10px" }} />
                </SkeletonTheme>
            }
          </div>

          <div className='mainContentSection w-100 overflow-auto d-flex flex-column'>
            <div className='d-flex align-items-center headerBar'>
              <button className='themeButtons rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                <MenuIcon />
              </button>
              <div className='w-100  d-flex align-items-center justify-content-end gap-3 gap-md-4 gap-lg-5 gap-xl-5 gap-xxl-5 px-lg-5 flex-wrap'>
                <div className='d-none gap-2 align-items-center upperMoonsSearch'>
                  <SearchIcon />
                  <input type="search" placeholder='search' />
                </div>
                <div className='d-flex gap-3 align-items-center upperMoons'>
                  <MarkEmailUnreadIcon onClick={(e) => { setShowSideOverlayLogs(true); getAllLogs(); }} />
                  <NotificationsActiveIcon />
                  <AccountCircleIcon onClick={() => { setShowUserOverlay(!showUserOverlay) }} ref={triggerted} />
                  <Overlay target={triggerted.current} show={showUserOverlay} placement="bottom">
                    {(props) => (
                      <Tooltip id="overlay-example" {...props}>
                        <div className="card">
                          <div className="card-header">
                            {user.userId}
                          </div>
                          <div className="card-body">
                            {user.designation}
                          </div>
                          <div className="card-footer">
                            <button className='btn btn-sm rounded-pill btn-danger px-3 py-2' onClick={(e) => { logoutFunc(); }}>Log Out</button>
                          </div>
                        </div>
                      </Tooltip>
                    )}
                  </Overlay>
                </div>
                {/* <button className='themeButtons rounded-pill px-3 py-1 d-flex align-items-center gap-2' onClick={() => { adminView === "SuperAdmin" ? setAdminView("Lab") : setAdminView("SuperAdmin") }}>{adminView === "SuperAdmin" ? <><ChangeCircleIcon />Lab</> : <><ChangeCircleIcon />Admin</>}</button> */}
              </div>
            </div>
            {
              !userLoading ?
                <>
                  {
                    contextViews === "Dashboard" ?
                      <DashboardContext serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                      :
                      contextViews === "Laboratory Lists" ?
                        <LaboratoryLists serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                        :
                        contextViews === "Items Lists" ?
                          <ItemsList serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                          :
                          contextViews === "User List" ?
                            <UserSetup serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                            :
                            contextViews === "Generated BarCode" ?
                              <GenerateBarcde serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                              :
                              contextViews === "On Printing" ?
                                <OnPrinting serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                :
                                contextViews === "On Assign Lab" ?
                                  <OnAssignLab serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                  :
                                  contextViews === "Product Type" ?
                                    <ProductType serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                    :
                                    contextViews === "Used Barcode List" ?
                                      <UsedBarcodeList serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                      :
                                      contextViews === "Add Warranty Card" ?
                                        <AddWarrantyCard serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                        :
                                        contextViews === "Issued Warranty Card" ?
                                          <WarrantyCard serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                          :
                                          contextViews === "Settings" ?
                                            <Settings serverUrl={serverURL} user={user} titleOfPage={contextViews} globalUserId={globalUserId} globalToken={globalToken} />
                                            :
                                            ""
                  }
                </>
                :
                <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                  <div className='w-100 themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>
                    <SkeletonTheme highlightColor='#d8733934'>
                      <Skeleton height={35} className='h-100' />
                    </SkeletonTheme>
                  </div>
                  <div className='p-2 overflow-auto rounded-0 h-100'>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                          <SkeletonTheme highlightColor='#d8733934'>
                            <Skeleton height={35} className='h-100' style={{ width: "100%", aspectRatio: "16/10" }} />
                          </SkeletonTheme>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                          <SkeletonTheme highlightColor='#d8733934'>
                            <Skeleton height={35} className='h-100' style={{ width: "100%", aspectRatio: "16/10" }} />
                          </SkeletonTheme>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
            }
          </div>
        </div>
      </div>

      <Offcanvas show={showSideOverlay} onHide={() => { setShowSideOverlay(false); }}>
        <Offcanvas.Header closeButton className='d-flex align-items-start'>
          <Offcanvas.Title>
            <img src="https://www.dentaldirekt.de/themes/custom/webksdct/logo.svg" alt="" className='w-100 mt-1 mb-5' style={{ maxWidth: "150px" }} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {
            !userLoading ?
              adminView === "SuperAdmin" ?
                <>

                  <button className={`leftMenueButtons ${contextViews === "Dashboard" ? "active" : ""}`} onClick={(e) => { setContextViews("Dashboard"); setShowSideOverlay(false); }}><DashboardCustomizeIcon style={{ width: ".8em" }} />Dashboard</button>
                  <button className={`leftMenueButtons ${contextViews === "Laboratory Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Laboratory Lists"); setShowSideOverlay(false); }}><BiotechIcon style={{ width: ".8em" }} /> Laboratory Lists</button>
                  <button className={`leftMenueButtons ${contextViews === "Items Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Items Lists"); setShowSideOverlay(false); }}><ChecklistIcon style={{ width: ".8em" }} /> Items Lists</button>
                  <button className={`leftMenueButtons ${contextViews === "User List" ? "active" : ""}`} onClick={(e) => { setContextViews("User List"); setShowSideOverlay(false); }}><RecentActorsIcon style={{ width: ".8em" }} /> User List</button>
                  {/* <button className={`leftMenueButtons ${contextViews === "Lab Registtration" ? "active" : ""}`} onClick={(e) => { setContextViews("Lab Registtration"); }}><ScienceIcon style={{ width: ".8em" }} />Lab Registtration</button> */}
                  {/* <button className={`leftMenueButtons ${contextViews === "Create Items Lists" ? "active" : ""}`} onClick={(e) => { setContextViews("Create Items Lists"); }}><FeaturedPlayListIcon style={{ width: ".8em" }} />Create Items Lists</button> */}
                  <button className={`leftMenueButtons ${contextViews === "Generated BarCode" ? "active" : ""}`} onClick={(e) => { setContextViews("Generated BarCode"); setShowSideOverlay(false); }}><QrCode2Icon style={{ width: ".8em" }} />Generated BarCode</button>
                  <button className={`leftMenueButtons ${contextViews === "On Printing" ? "active" : ""}`} onClick={(e) => { setContextViews("On Printing"); setShowSideOverlay(false); }}><QrCode2Icon style={{ width: ".8em" }} />On Printing</button>
                  <button className={`leftMenueButtons ${contextViews === "On Assign Lab" ? "active" : ""}`} onClick={(e) => { setContextViews("On Assign Lab"); setShowSideOverlay(false); }}><QrCode2Icon style={{ width: ".8em" }} />On Assign Lab</button>
                  <button className={`leftMenueButtons ${contextViews === "Product Type" ? "active" : ""}`} onClick={(e) => { setContextViews("Product Type"); setShowSideOverlay(false); }}><QrCode2Icon style={{ width: ".8em" }} />Product Type</button>
                  <button className={`leftMenueButtons ${contextViews === "Used Barcode List" ? "active" : ""}`} onClick={(e) => { setContextViews("Used Barcode List"); setShowSideOverlay(false); }}><QrCode2Icon style={{ width: ".8em" }} />Used Barcode List</button>
                  <button className={`leftMenueButtons ${contextViews === "Settings" ? "active" : ""}`} onClick={(e) => { setContextViews("Settings"); setShowSideOverlay(false); }}><HealthAndSafetyIcon style={{ width: ".8em" }} />Settings</button>
                </>
                :
                <>
                  <button className={`leftMenueButtons ${contextViews === "Dashboard" ? "active" : ""}`} onClick={(e) => { setContextViews("Dashboard"); setShowSideOverlay(false); }}><DashboardCustomizeIcon style={{ width: ".8em" }} />Dashboard</button>
                  <button className={`leftMenueButtons ${contextViews === "Add Warranty Card" ? "active" : ""}`} onClick={(e) => { setContextViews("Add Warranty Card"); setShowSideOverlay(false); }}><DashboardCustomizeIcon style={{ width: ".8em" }} />Add Warranty Card</button>
                  <button className={`leftMenueButtons ${contextViews === "Issued Warranty Card" ? "active" : ""}`} onClick={(e) => { setContextViews("Issued Warranty Card"); setShowSideOverlay(false); }}><HealthAndSafetyIcon style={{ width: ".8em" }} />Issued Warranty Card</button>

                </>
              :
              <SkeletonTheme highlightColor='#d8733934'>
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
                <Skeleton height={35} style={{ marginBottom: "10px" }} />
              </SkeletonTheme>
          }
        </Offcanvas.Body>
      </Offcanvas>





      <Offcanvas show={showSideOverlayLogs} placement={"end"} onHide={() => { setShowSideOverlayLogs(false); }}>
        <Offcanvas.Header closeButton className='d-flex align-items-start'>
          <Offcanvas.Title>
            <img src="https://www.dentaldirekt.de/themes/custom/webksdct/logo.svg" alt="" className='w-100 mt-1 mb-5' style={{ maxWidth: "150px" }} />
            <div className="text-start themeTextColor fs-5 mb-2 w-100">Logs</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>


          {
            logs.length > 0 ?
              logs.map((data, key) => {
                return (
                  <React.Fragment key={key}>
                    <Accordion>
                      <Accordion.Item eventKey={key}>
                        <Accordion.Header>
                          <div className='d-flex flex-column gap-1'>
                            <span className='themeTextColor'>
                              {data.changes.Name}
                            </span>
                            <span>
                              {new Date(data.date).toLocaleString()}
                            </span>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className='fw-bold m-0 p-0 upperMoonsSearchBackground themeTextColor p-1 text-center'>Details</p>
                          {
                            Object.keys(data.changes.Details).map((dataAd, key) => {
                              return (
                                <div className=' d-flex flex-column mb-1 p-1' key={key}>
                                  <span className='fw-bold'>{dataAd}:</span>
                                  <span className='text-break'>{JSON.stringify(data.changes.Details[dataAd])}</span>
                                </div>
                              )
                            })
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </React.Fragment>
                )
              })
              :
              <div className="alert alert-light p-1 m-0 shadow-sm text-center themeTextColor">No Logs for now</div>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Dashboard